'use strict'

import baseConfig from './base'

let backendHost = ''
const apiVersion = 'v1'
const hostname = window && window.location && window.location.hostname

//Staging server
if (hostname === 'belepes.staging.beeker.hu') {
  backendHost = 'https://api.beeker.hu'
}

//Production server
if (hostname === 'belepes.beeker.hu') {
  backendHost = 'https://api.beeker.hu'
}

//Local server
if (hostname === 'localhost') {
  backendHost = 'http://api.beeker.local'
}

const API_ROOT = `${backendHost}/api/${apiVersion}/`
let config = {
  appEnv: 'dev',
  ENDPOINT_BASE_URL: API_ROOT,
  language: 'hu'
}

export default Object.freeze(Object.assign({}, baseConfig, config))



// WEBPACK FOOTER //
// ./src/config/dev.js